import { GraphQLClient } from 'graphql-request'
import { VENDURE_HUB_URL } from './constants'

export const clientApi = new GraphQLClient(VENDURE_HUB_URL)
